import type {
  GroupByDate,
  GroupsSearchSchema,
  PatientFilter,
  SlicesResultFilterSchema,
  UserTableFilterSchema,
} from "./schema";

//TODO: i don't like it, make it better
export type MergeActions<T extends readonly unknown[]> = T[number];

export type PatientFilterAction =
  | {
      type: "SET_FILTER";
      filterName: "age";
      value: PatientFilter["age"];
    }
  | {
      type: "SET_FILTER";
      filterName: "groupId";
      value: PatientFilter["groupId"];
    }
  | {
      type: "SET_FILTER";
      filterName: "gender";
      value: PatientFilter["gender"];
    }
  | { type: "SET_FILTER"; filterName: "area"; value: PatientFilter["area"] }
  | { type: "RESET_FILTER" };

export interface GroupByDateFilterAction {
  type: "SET_FILTER";
  filterName: "groupBy";
  value: GroupByDate;
}

export type GroupsFilterAction =
  | {
      type: "SET_FILTER";
      filterName: "search";
      value: GroupsSearchSchema["search"];
    }
  | {
      type: "SET_FILTER";
      filterName: "page";
      value: GroupsSearchSchema["page"];
    }
  | { type: "RESET_FILTER" };

export type UsersTableFilterAction =
  | {
      type: "SET_FILTER";
      filterName: "search";
      value: UserTableFilterSchema["search"];
    }
  | {
      type: "SET_FILTER";
      filterName: "status";
      value: UserTableFilterSchema["status"];
    }
  | { type: "RESET_FILTER" };

export type SlicesResultsFilterAction =
  | {
      type: "SET_FILTER";
      filterName: "slice";
      value: SlicesResultFilterSchema["slice"];
    }
  | { type: "RESET_FILTER" };

interface SetFilterAction<T extends Record<string, unknown>> {
  type: "SET_FILTER";
  filterName: keyof T;
  value: T[keyof T];
}

interface ResetFilterAction {
  type: "RESET_FILTER";
}

type FilterAction<T extends Record<string, unknown>> =
  | SetFilterAction<T>
  | ResetFilterAction;

export const filterReducer = <T extends Record<string, unknown>>(
  state: T,
  action: FilterAction<T>,
) => {
  switch (action.type) {
    case "SET_FILTER":
      return { ...state, [action.filterName]: action.value };
    case "RESET_FILTER": {
      const resetState = Object.keys(state).reduce(
        (acc, key) => {
          return {
            ...acc,
            [key]: undefined,
          };
        },
        {} as typeof state,
      );
      return resetState;
    }
    default:
      return state;
  }
};
